export class RecentlyViewed extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()

    this.sectionId = 'recently-viewed-product'

    this.updateLocalStorage()
    this.initializeRecentlyViewed()
  }

  setupListeners () {
    super.setupListeners()

    this.manageOwlCarousel = this.manageOwlCarousel.bind(this)

    this.listeners.add(window, 'resize', this.manageOwlCarousel)
  }

  initializeRecentlyViewed() {
    // for each item in the local storate, add a product card
    const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || []
    recentlyViewed.reverse()

    if (recentlyViewed.length > 0) {
      recentlyViewed.forEach(productUrl => {
        if (productUrl !== this.dataset?.productUrl) {
          this.renderDrawerContent(productUrl)
        }
      })
    }
  }

  updateLocalStorage() {
    const product = this.dataset?.productUrl
    if (product) {
      let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
      if (!recentlyViewed.includes(product)) {
        recentlyViewed.push(product);
        localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
      }
    }
  }

  async renderDrawerContent (productUrl) {
    const html = await this.sectionRenderer.fetchSingle(this.sectionId, productUrl)
    const innerHtml = this.sectionRenderer.getInnerHtml(html)
    
    if (!html || !innerHtml) return

    const productCard = document.createElement('div')
    productCard.classList.add('sec-CollectionCarousel_ProductCard')
    productCard.innerHTML = innerHtml

    this.els.carousel.element.appendChild(productCard)
    this.manageOwlCarousel()

    this.ariaHidden = false
  }


  manageOwlCarousel() {
    this.destroyGallery(this.els?.carousel)

    if ($(window).width() > 768) {
      this.initializeGallery(this.els?.carousel, 4)
    } else {
      this.initializeGallery(this.els?.carousel, 1.5)
    }
  }

  initializeGallery(carousel, numberOfSlides) {
    if (typeof jQuery !== 'undefined' && carousel) {
      $(carousel.selector).owlCarousel({
        items: numberOfSlides || 1,
        loop: carousel.element.dataset.loop === 'true',
        margin: 20,
        nav: carousel.element.dataset.nav === 'true',
        navText: ["<span class=\"visually-hidden\"></span><i class=\"la la-angle-left\"></i>", "<span class=\"visually-hidden\"></span><i class=\"la la-angle-right\"></i>"],
        dots: carousel.element.dataset.dots === 'true',
        navContainer: '.sec-RecentlyViewed_Nav',
      })
    } else {
      console.error('jQuery or OwlCarousel not loaded.', typeof jQuery, carousel)
    }
  }

  destroyGallery(carousel){
    $(carousel.selector).trigger('destroy.owl.carousel')
  }

  /**
   * @returns {sectionRenderer} The BAO sectionRenderer class
   */
  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }
}

customElements.define('recently-viewed', RecentlyViewed)